/** Ligne « Effet sur les prix : pain, plein, loyer, énergie (N+1 → N+5) » (PRD §14.2, BACKLOG H4). */
import type { PriceEffects, PriceItem } from "../engine-adapter.js";
import { pctDelta } from "../format.js";
import type { Store } from "../state.js";
import { paramsSourceButton } from "./tangible.js";

const ITEMS: Array<[PriceItem, string]> = [
  ["bread", "pain"],
  ["fuel", "plein"],
  ["rent", "loyer"],
  ["energy", "énergie"],
];

/** true si au moins un poste bouge d'au moins 0,05 % (affichage au dixième). */
export function hasPriceEffect(pe: PriceEffects | null): boolean {
  return !!pe && ITEMS.some(([k]) => pe[k] && (Math.abs(pe[k]!.n1) >= 0.05 || Math.abs(pe[k]!.n5) >= 0.05));
}

export function priceLine(store: Store, pe: PriceEffects | null, opts: { compact?: boolean } = {}): string {
  if (!pe) return "";
  const parts = ITEMS.filter(([k]) => pe[k]).map(([k, label]) => {
    const d = pe[k]!;
    const same = Math.abs(d.n1 - d.n5) < 0.05;
    const cls = d.n5 > 0.05 ? "down" : d.n5 < -0.05 ? "up" : "flat";
    return `<span class="${cls}">${label} ${pctDelta(d.n1)}${same ? "" : ` → ${pctDelta(d.n5)}`}</span>`;
  });
  if (!parts.length) return "";
  const src = paramsSourceButton(store, "Effet sur les prix", "price", ["Transmission des prélèvements aux prix calculée par le moteur : TVA → prix immédiat, impôts de production et cotisations → prix et salaires avec délai, TICPE → carburants."]);
  return `<p class="price ${opts.compact ? "xs" : "sm"}">Effet sur les prix${src} : ${parts.join(", ")} <span class="mut">(N+1 → N+5)</span></p>`;
}
